<template>
  <div>
    <h2 class="content-block">Pivot Practice</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxPivotGrid
          id="sales"
          :allow-sorting-by-summary="true"
          :allow-sorting="true"
          :allow-filtering="true"
          :allow-expand-all="true"
          :height="440"
          :show-borders="true"
          :data-source="dataSource"
        >
          <DxFieldChooser :enabled="false" />
        </DxPivotGrid>

        <DxPivotGrid
          id="cabang"
          :allow-sorting-by-summary="true"
          :allow-sorting="true"
          :allow-filtering="true"
          :allow-expand-all="true"
          :show-borders="true"
          :data-source="dataSourceCabang"
          @exporting="onExporting"
        >
          <DxFieldChooser :enabled="false" />
          <DxExport :enabled="true" />
        </DxPivotGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import axios from "axios";
import DxPivotGrid, {
  DxExport,
  DxFieldChooser,
} from "devextreme-vue/pivot-grid";
import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source";

import { sales } from "./pivot-practice-data.js";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { exportPivotGrid } from "devextreme/excel_exporter";
export default {
  components: {
    DxExport,
    DxPivotGrid,
    DxFieldChooser,
  },
  data() {
    return {
      storeCabang: null,
      dataSourceCabang: null,

      storeSales: null,

      dataSource: null,
    };
  },
  async mounted() {
    this.storeCabang = await this.fetchData();
    console.log("storecabang", this.storeCabang);
    console.log("sales", sales);
    this.dataSourceCabang = new PivotGridDataSource({
      fields: [
        {
          caption: "Cabang",
          width: 120,
          dataField: "cabang",
          area: "row",
        },
        {
          dataField: "tgl",
          dataType: "date",
          area: "column",
        },
        {
          caption: "gapok",
          dataField: "gaji_pokok",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Tunj. Perusahaan",
          dataField: "tun_perusahaan",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Tunj. Jabatan",
          dataField: "tun_jabatan",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Tunj. Kemahalan",
          dataField: "tun_kemahalan",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Tunj. Air",
          dataField: "tun_air",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Tunj. Transport",
          dataField: "tun_transport",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Tunj. Pangan",
          dataField: "tun_pangan",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Tun kesehatan",
          dataField: "tun_kesehatan",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Jml Tdk Hadir",
          dataField: "jml_tdk_hadir",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Pot. 5%",
          dataField: "pot_5_persen",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Jml Bruto",
          dataField: "jml_bruto",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Tunj. PPH",
          dataField: "tun_pph",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Pot. Kesehatan",
          dataField: "pot_kesehatan",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Pot. BPJS TK 3",
          dataField: "pot_bpjs_tk_tiga_program",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Pot. BPJS TK 4",
          dataField: "pot_bpjs_tk_empat_program",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Pot. Pensiun Jiwasraya",
          dataField: "pot_pensiun",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Pot. PPH",
          dataField: "pot_pph",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        {
          caption: "Total Diterima",
          dataField: "total_diterima",
          dataType: "number",
          summaryType: "sum",
          format: "#,##0",
          area: "data",
        },
        // {
        //   caption: "KMK",
        //   dataField: "kenaikan_masa_kerja",
        //   dataType: "number",
        //   summaryType: "sum",
        //   format: "#,##0",
        //   area: "data",
        // },
        // {
        //   caption: "Tunj. Kesehatan",
        //   dataField: "tun_kesehatan",
        //   dataType: "number",
        //   summaryType: "sum",
        //   format: "#,##0",
        //   area: "data",
        // },
        // {
        //   caption: "Jml tdk hadir",
        //   dataField: "jml_tdk_hadir",
        //   dataType: "number",
        //   summaryType: "sum",
        //   format: "#,##0",
        //   area: "data",
        // },
        // {
        //   caption: "Pot. 5%",
        //   dataField: "pot_5_persen",
        //   dataType: "number",
        //   summaryType: "sum",
        //   format: "#,##0",
        //   area: "data",
        // },
        // {
        //   caption: "Pot. BPJS TK",
        //   dataField: "tun_bpjs_tk_satu_sembilanbelas_persen",
        //   dataType: "number",
        //   summaryType: "sum",
        //   format: "#,##0",
        //   area: "data",
        // },
        // {
        //   caption: "Jml Bruto",
        //   dataField: "jml_bruto",
        //   dataType: "number",
        //   summaryType: "sum",
        //   format: "#,##0",
        //   area: "data",
        // },
        // {
        //   caption: "Pot. Kesehatan",
        //   dataField: "pot_kesehatan",
        //   dataType: "number",
        //   summaryType: "sum",
        //   format: "#,##0",
        //   area: "data",
        // },
        // {
        //   caption: "Pot. BPJSK TK",
        //   dataField: "pot_bpjs_tk_satu_sembilanbelas_persen",
        //   dataType: "number",
        //   summaryType: "sum",
        //   format: "#,##0",
        //   area: "data",
        // },
        // {
        //   caption: "Total diterima",
        //   dataField: "total_diterima",
        //   dataType: "number",
        //   summaryType: "sum",
        //   format: "#,##0",
        //   area: "data",
        // },
      ],
      store: this.storeCabang,
    });

    this.storeSales = sales;
    this.dataSource = new PivotGridDataSource({
      fields: [
        {
          caption: "Region",
          width: 120,
          dataField: "region",
          area: "row",
        },
        {
          caption: "City",
          dataField: "city",
          width: 150,
          area: "row",
          selector(data) {
            return `${data.city} (${data.country})`;
          },
        },
        {
          dataField: "date",
          dataType: "date",
          area: "column",
        },
        {
          caption: "Sales",
          dataField: "amount",
          dataType: "number",
          summaryType: "sum",
          format: "currency",
          area: "data",
        },
      ],
      store: this.storeSales,
    });
  },

  methods: {
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Rekap Gaji");

      exportPivotGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Rekap Gaji.xlsx"
          );
        });
      });
      e.cancel = true;
    },

    async fetchData() {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      var data = {
        pegawai_status_id: 2,
      };
      const response = await axios.post(
        "http://127.0.0.1/api/rekap_gaji_pivot",
        data,
        config
      );
      return response.data[0];
    },
  },
};
</script>
